import React, {Component} from 'react'
import _ from 'lodash'

class AdsContainer extends Component {
    componentDidMount() {
        let ads = this.props.proxy.querySelectorAll('.publicity-container')

        if (ads.length > 0) {
            let ad = ads.length > 1
                ? _.shuffle(ads)
                    .pop()
                : ads[0]

            ad.style.display = 'block'
        }
    }

    render() {
        return <div></div>
    }
}

export default (AdsContainer)



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/AdsContainer.js